import { render, staticRenderFns } from "./TemplatesPublishButton.vue?vue&type=template&id=5113333d&scoped=true"
import script from "./TemplatesPublishButton.vue?vue&type=script&lang=js"
export * from "./TemplatesPublishButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5113333d",
  null
  
)

export default component.exports